import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';
import * as MatchInfo from 'constants/MatchInfo';

const BASKETBALL_NCAA_SCORE_MAP = {};
BASKETBALL_NCAA_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod],
        fouls: ScoreType.FirstPeriodFouls,
        possession: ScoreType.BallPossession
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.FIRST_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        fouls: ScoreType.SecondPeriodFouls,
        possession: ScoreType.BallPossession
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.SECOND_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.OVERTIME] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.Overtime,
        possession: ScoreType.BallPossession
    }
};

BASKETBALL_NCAA_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_FINISHED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.Overtime
    }
};

export default BASKETBALL_NCAA_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/BasketballNCAA/ScoreMap.js